import { BusinessId } from "../shared/generated/enums";
import { HelpLink } from "../shared/shell";
import { SoilUnit } from "../shared/soil";
import { OmniaAppId } from "../shared/types";
import { Features } from "./types";

export function getAmino(production: boolean): Features {

    return {

        appId: OmniaAppId.Amino,

        brand: {
            name: "Amino",
            images: "amino",
            logoDark: "images/brand/amino/tagline-200-dark.png",
            logoLight: "images/brand/amino/tagline-200.png",
            icon: "/images/brand/amino/icon.svg",
            terramap: "TerraMap"
        },

        login: "default",
        tcs: false,
        sso: false,
        holdingUserPermissions: false,

        usersnapKey: (production ? '17e1749a-3b80-4e97-8f47-8708831368d8' : 'eef9dc9b-b742-455f-8e52-b7030d7d903a'),

        ui: {
            mainMenu: {
                groupDataModules: true
            }
        },

        regions: undefined,

        i18n: false,

        SRID: 4326,

        account: {
            tcs: false,
            sso: false,
            resetPasswordBeforeLogin: true
        },

        support: {
            phone: "+44 01945 753110",
            email: "omnia.support@hlhltd.co.uk",
            getHelpLinks: () => ({} as Record<string | number, HelpLink[]>)
        },

        features: {

            holding: {
                timezones: false,
                postTown: false,
                weather: true,
                business: {
                    available: true,
                    ids: [BusinessId.Hutchinsons],
                }
            },

            fields: {
                cropAttributes: true,
                variety: "list",
                destructionDate: true,
                yield: "crop",
                soilTexture: { available: true, required: true },
                fieldMargin: {},
                cropManagementOptions: false
            },

            nvz: false,
            soilMgmtPlans: false,
            facts: false,

            soil: {
                module: true,
                morgan: true,
                units: [
                    { id: SoilUnit.Ppm },
                    { id: SoilUnit.Index },
                    { id: SoilUnit.Morgan },
                    { id: SoilUnit.KgHa }
                ]
            },

            seeds: true,
            nutrition: true,
            genericPlans: true,
            sprayPlans: false,
            prescriptionPlans: true,

            manure: false,

            stocks: {
                seeds: true,
                ferts: true,
                manure: true,
                costs: false,
                v2: false
            },

            diary: {
                enabled: false
            },

            climate: false,
            planning: true,

            maps: {
                geolocationQuerySuffix: undefined,
                basemaps: {
                    ordnanceSurvey: false
                },
            },

            layers: {
                holding: true
            },

            satelliteImagery: false,

            import: {

                sources: {
                    documents: true,
                    gatekeeper: false,
                    glgm: false,
                    soilAnalysis: true,
                    plantVision: true,
                    soyl: true,
                    rpa: true,
                    rhiza: true,
                    johnDeere: {
                        enableOperations: false
                    }
                },

                soiloptix: {
                    sharepointFileProvider: false
                }

            },

            export: {

                enabled: true,

                layers: {
                    gatekeeperShp: false
                }

            },

            reports: {
                email: false,
            },

            connections: {
                dropbox: false,
                johnDeere: false,
                claas: false,
                fieldView: false,
                glgm: false,
                connect: true
            },

        },


    }

}
